import { Row } from "reactstrap";
import ProfileMail from "./ProfileMail";
import ProfileName from "./ProfileName";

const ProfileDetail = () => {
  return (
    <div className="info">
      <Row className="g-3 step3">
        <ProfileName />
      </Row>
      <hr />
      <ProfileMail />
    </div>
  );
};

export default ProfileDetail;
